import { render, staticRenderFns } from "./oidc.vue?vue&type=template&id=9e5ae972&scoped=true&"
import script from "./oidc.vue?vue&type=script&lang=js&"
export * from "./oidc.vue?vue&type=script&lang=js&"
import style0 from "./oidc.vue?vue&type=style&index=0&id=9e5ae972&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e5ae972",
  null
  
)

export default component.exports